module.exports = __webpack_public_path__ + "img/vertical_4_6_7042.6a987e48.png";